import React, { useState, useMemo } from 'react';

import { useQuery, useMutation } from '@tanstack/react-query';

import Button from '../../../Button';
import Select from '../../../Form/Select';

import BorrowerService from '../../../../services/BorrowerService';
import formatBorrowerName from '../../../../helpers/formatBorrowerName';
import FreshcallerCallService from '../../../../services/FreshcallerCallService';
import { useUiContext } from '../../../../context/UiContext';

export default function AssociateWithBorrower({ call, refetch }) {
  const [showSelect, setShowSelect] = useState(false);
  const [selectedBorrower, setSelectedBorrower] = useState('');

  const { showToast } = useUiContext();

  const { data: borrowers } = useQuery({
    queryKey: ['borrowers'],
    queryFn: BorrowerService.getBorrowers,
  });

  const { mutate: associateWithBorrower } = useMutation({
    mutationFn: () =>
      FreshcallerCallService.updateFreshcallerCall({
        callId: call.id,
        borrowerId: selectedBorrower,
        excludeFromLog: false,
      }),
    onSuccess: () => {
      showToast({
        text: 'Success',
        type: 'success',
      });
      refetch();
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  const borrowerOptions = useMemo(() => {
    if (!borrowers) return [];

    return borrowers.map((borrower) => ({
      value: borrower.id,
      label: `${formatBorrowerName(borrower)} - ${
        borrower.billing_address_line_1
      }`,
    }));
  }, [borrowers]);

  return (
    <div>
      {showSelect ? (
        <div className="flex items-center gap-4">
          <div>
            <Select
              options={borrowerOptions}
              fixedPosition
              setFieldValue={(_, val) => setSelectedBorrower(val)}
              value={selectedBorrower}
              placeholder="Select a borrower"
              fullWidth
            />
          </div>
          <div className="flex gap-5">
            <Button
              onClick={associateWithBorrower}
              className="h-8"
              disabled={!selectedBorrower}
            >
              Save
            </Button>

            <button
              type="button"
              className="underline bg-transparent border-none text-blue-500 hover:text-blue-700 focus:outline-none dark:text-blue-300 dark:hover:text-blue-500"
              onClick={() => {
                setShowSelect(false);
                setSelectedBorrower('');
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      ) : (
        <Button
          className="h-6"
          onClick={() => setShowSelect(true)}
          variant="secondary"
        >
          Associate with borrower
        </Button>
      )}
    </div>
  );
}
